import * as React from 'react';
import { useDrop } from 'react-dnd';

// Constants
import {
    EVENT_TIMELINE_CELL,
    EVENT_TABLE_ROW,
    HEIGHT
    // @ts-ignore
} from '../../../../../../../../constants';

interface OwnProps {
    children: React.ReactElement;
    groupId: number;
    date: string;
}

type Props = OwnProps;

const EventsTimelineCellDropTarget = (props: Props): React.ReactElement => {
    const { groupId, date, children } = props;
    const [{ isOver }, drop] = useDrop({
        accept: [EVENT_TIMELINE_CELL, EVENT_TABLE_ROW],
        drop: () => {
            return { nextGroupId: groupId, date };
        },
        collect: (monitor) => {
            return {
                isOver: monitor.isOver(),
                item: monitor.getItem()
            };
        }
    });

    return (
        <td
            ref={drop}
            // HACK inline styles
            style={{
                padding: 0,
                paddingTop: 5,
                position: 'relative',
                verticalAlign: 'top',
                borderRadius: 0,
                overflow: 'visible'
            }}
        >
            {children}
            {isOver && (
                <div
                    style={{
                        position: 'relative',
                        height: HEIGHT,
                        marginBottom: 5
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 16,
                            bottom: 0,
                            left: 5,
                            border: '1px dashed rgba(0,0,0,0.4)',
                            borderRadius: 3
                        }}
                    />
                </div>
            )}
            {!isOver && (
                <div
                    style={{
                        height: 24
                    }}
                />
            )}
        </td>
    );
};

export default EventsTimelineCellDropTarget;
